import axios from 'api/axios';

export const deleteLogo = (id: string) =>
    axios({
        url: `/file/${id}`,
        method: 'DELETE'
    });
